import { createRoot } from "@wordpress/element";
import App from "./components/App";

document
	.querySelectorAll(".wp-block-world-world-forecast-prevision")
	.forEach((el) => {
		const root = el.querySelector(".world-forecast-prevision__app");
		if (root) {
			createRoot(root).render(<App />);
		}
	});
